import { render, staticRenderFns } from "./MerchantsView.vue?vue&type=template&id=6d63026e&scoped=true&"
import script from "./MerchantsView.vue?vue&type=script&lang=js&"
export * from "./MerchantsView.vue?vue&type=script&lang=js&"
import style0 from "./MerchantsView.vue?vue&type=style&index=0&id=6d63026e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63026e",
  null
  
)

export default component.exports